
import React, { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import swal from "sweetalert";
import { API } from "../../../config/api";
import { Container, OverlayTrigger, Popover, Row } from "react-bootstrap";
import { Input } from "reactstrap";

const DentalTable = () => {
    const [getData, setGetData] = useState([]);
    const [filteredData, setFilteredData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [page, setPage] = useState(1);
    const [limit, setLimit] = useState(10);
    const [ascending, setAscending] = useState(true);
    const [search, setSearch] = useState("");

    const token = localStorage.getItem("token");

    const fetchParams = {
        headers: { Authorization: `${token}`, "Content-Type": "application/json" }
    };

    const LoadingDots = () => {
        const [dots, setDots] = useState("");
        useEffect(() => {
            let count = 0;
            const interval = setInterval(() => {
                count = (count + 1) % 4;
                setDots(".".repeat(count));
            }, 500);
            return () => clearInterval(interval);
        }, []);
        return (
            <div style={{ textAlign: "center", fontWeight: "bold", padding: "20px" }}>
                LOADING{dots}
            </div>
        );
    };

    const GetResponseData = async () => {
        try {
            setLoading(true);
            const response = await API.get(
                `emr-service/dental-mains?page=${page}&limit=${limit}&ascending=${ascending ? 1 : 0}`,
                fetchParams
            );
            if (response?.status === 200) {
                setGetData(response.data.data.data);
                setFilteredData(response.data.data.data);
            }
            setLoading(false);
        } catch (error) {
            setLoading(false);
            swal({
                title: "Failed",
                text:
                    error.response?.data?.message || error.message || "Terjadi kesalahan",
                icon: "error",
                timer: 3000,
                buttons: false
            });
        }
    };

    useEffect(() => {
        GetResponseData();
    }, [page, limit, ascending]);

    useEffect(() => {
        if (!search) {
            setFilteredData(getData);
        } else {
            const filtered = getData.filter(item =>
                item?.fullname?.toLowerCase().includes(search.toLowerCase()) ||
                item.appointment?.anamnesa?.toLowerCase().includes(search.toLowerCase()) ||
                item.appointment?.code?.toLowerCase().includes(search.toLowerCase())
            );
            setFilteredData(filtered);
        }
    }, [search, getData]);

    const columns = [
        { name: "Nama", selector: row => row?.fullname, wrap: true },
        { name: "Code Appointment", selector: row => row.appointment?.code, wrap: true },
        { name: "Anamnesa", selector: row => row.appointment?.anamnesa, wrap: true },
        { name: "Waktu", selector: row => row.appointment?.time, wrap: true },
        {
            name: "",
            selector: row => row.occlusis,
            wrap: true,
            cell: row => {
                const firstRow = [
                    { key: "occlusis", label: "Oklusi", items: row.occlusis },
                    { key: "torusPalatinus", label: "Palatinus", items: row.torus_palatinuses },
                    { key: "torusMandibularis", label: "Mandibularis", items: row.torus_mandibularises },
                    { key: "palata", label: "Palatum", items: row.palata },
                    { key: "diastemas", label: "Diastema", items: row.diastemas },
                    { key: "anomalis", label: "Anomali", items: row.anomalis }
                ];

                const secondRow = [
                    { key: "conditions", label: "Kondisi", items: row.conditions },
                    { key: "restorations", label: "Restorasi", items: row.restorations },
                    { key: "restoration_materials", label: "Bahan Restorasi", items: row.restoration_materials },
                    { key: "protesas", label: "Protesa", items: row.protesas },
                    { key: "protesa_materials", label: "Bahan Protesa", items: row.protesa_materials }
                ];

                const renderRow = (data) => {
                    const filtered = data.filter(p => p.items && p.items.length > 0);
                    if (filtered.length === 0) return null;

                    return (
                        <div style={{ display: "flex", flexDirection: "row", gap: "10px", marginBottom: "8px" }}>
                            {filtered.map((p, idx) => {
                                const popover = (
                                    <Popover id={`popover-${p.key}-${row.id}`}>
                                        <Popover.Body>
                                            <ol style={{ paddingLeft: "20px", margin: 0 }}>
                                                {p.items?.map((item, i) => {
                                                    const fieldMap = {
                                                        conditions: "dental_condition",
                                                        restorations: "dental_restoration",
                                                        restoration_materials: "dental_restoration_material",
                                                        protesas: "dental_protesa",
                                                        protesa_materials: "dental_protesa_material"
                                                    };

                                                    const mainField = fieldMap[p.key];
                                                    const detailObj = mainField ? item?.[mainField] : null;

                                                    return (
                                                        <li key={i}>
                                                            <strong>{detailObj?.description || item?.description || "-"}</strong>
                                                            {item?.tooth_number ? ` (Gigi ${item.tooth_number})` : ""}
                                                            {detailObj?.display_name && (
                                                                <div style={{ fontSize: "12px", color: "#666" }}>
                                                                    {detailObj.display_name}
                                                                </div>
                                                            )}
                                                        </li>
                                                    );
                                                })}
                                            </ol>

                                        </Popover.Body>
                                    </Popover>
                                );

                                return (
                                    <OverlayTrigger
                                        key={idx}
                                        trigger={["hover", "focus"]}
                                        placement="top"
                                        overlay={popover}
                                    >
                                        <div
                                            style={{
                                                display: "flex",
                                                border: "none",
                                                padding: "0px 10px",
                                                cursor: "pointer",
                                                borderRadius: "3px",
                                                backgroundColor: "#a9b5df",
                                                color: "white",
                                                fontWeight: "bold",
                                                width: "120px",
                                                justifyContent: "center",
                                                alignItems: "center"
                                            }}
                                        >
                                            {p.label}
                                        </div>
                                    </OverlayTrigger>
                                );
                            })}
                        </div>
                    );
                };

                return (
                    <div style={{ display: "flex", flexDirection: "column" }}>
                        {renderRow(firstRow)}
                        {renderRow(secondRow)}
                    </div>
                );
            }
        }
    ];

    return (
        <Row className="mt-2">
            <Container>
                <div
                    style={{
                        display: "flex",
                        justifyContent: "flex-end",
                        marginBottom: "10px",
                    }}
                >
                    <form
                        onSubmit={(e) => e.preventDefault()}
                        style={{
                            display: "flex",
                            alignItems: "center",
                            border: "1px solid #ccc",
                            borderRadius: "4px",
                            overflow: "hidden",
                            height: "32px",
                            backgroundColor: "#f5f5f5",
                        }}
                    >
                        <input
                            type="text"
                            placeholder="Cari..."
                            value={search}
                            onChange={(e) => setSearch(e.target.value)}
                            style={{
                                border: "none",
                                outline: "none",
                                padding: "0px 10px",
                                fontSize: "13px",
                                backgroundColor: "transparent",
                                width: "200px",
                                height: "100%",
                            }}
                        />
                        <button
                            type="submit"
                            style={{
                                backgroundColor: "#3D64FF",
                                color: "white",
                                border: "none",
                                padding: "0px 15px",
                                cursor: "pointer",
                                fontSize: "13px",
                                fontWeight: "bold",
                                height: "100%",
                                display: "flex",
                                alignItems: "center",
                            }}
                        >
                            Search
                        </button>
                    </form>
                </div>

                <div style={{ width: "100%", overflowX: "auto" }}>
                    <div style={{ minWidth: "100px" }}>
                        <DataTable
                            title="Satu Sehat"
                            columns={columns}
                            data={filteredData}
                            progressPending={loading}
                            progressComponent={<LoadingDots />}
                            pagination
                            paginationServer
                            paginationTotalRows={filteredData.length}
                            onChangePage={setPage}
                            onChangeRowsPerPage={setLimit}
                            paginationPerPage={limit}
                            paginationRowsPerPageOptions={[5, 10, 15, 20]}
                            defaultSortField="created_at"
                            defaultSortAsc={ascending}
                            dense
                        />
                    </div>
                </div>
            </Container>
        </Row>
    );
};

export default DentalTable;
